<template>
  <div :class="$style.probability" @touchmove.prevent>
    <header>
      <i :class="`iconfont yw-xiangzuo ${$style.back}`" @click="back"></i>
      <p>礼包抽奖概率</p>
      <div :class="$style.typeList">
        <span 
          v-for="item in typeList" 
          :key="item.type" 
          :class="[activeTab === item.type ? $style.active : '']"
          @click="changeTab(item.type)"
        >{{ item.text }}</span>
      </div>
      <div :class="$style.condition">
        <span>单位：元</span>
      </div>
    </header>
    <div :class="$style.bonusList">
      <div v-for="(packet, packetIndex) in filterPackets" :key="packetIndex" :class="$style.bonusItem">
        <div :class="$style.count" v-if="!!packet.name">{{packet.name}}</div>
        <div :class="$style.count" v-else>
          活动奖金
          <span>{{handlePrice(packet)}}元</span>
        </div>
        <ul :class="$style.list">
          <li v-for="(interval, intervalIndex) in packet.money_options" :key="intervalIndex">
            <span :class="$style.price">{{ interval.min }}-{{ interval.max }}元现金红包</span>
            <span>获得红包概率{{ interval.proportion }}%</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { handlePrice } from '@/libs/business/red-envelope';

export default {
  name: '',
  props: ['options'],
  data () {
    return {
      activeTab: ''
    };
  },
  mounted() {
    this._initActiveTab()
  },
  computed: {
    ...mapState({
      typeList: state => state.redEnvelope.typeList,
      packets: state => state.redEnvelope.packets,
    }),
    filterPackets() {
      return this.packets.filter((item, index) => {
        if (index === 0) {
          return this.activeTab === this.typeList[0].type
        } else {
          return item.typeId === this.activeTab
        }
      });
    }
  },
  watch: {
    typeList() {
      this._initActiveTab()
    }
  },
  methods: {
    changeTab(type) {
      this.activeTab = type;
    },
    back() {
      this.$emit('close');
    },
    _initActiveTab() {
      if (this.typeList.length) this.activeTab = this.typeList[0].type
    },
    handlePrice(packet) {
      return handlePrice(packet)
    },
  }
}
</script>

<style lang="scss" module>
$font-lg: 15px;
$font-nm: 12px;
$font-sm: 9px;

.probability {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 344px;
  height: 348px;
  background: #ffffff;
  border-radius: 5px;
  overflow: auto;
  z-index: 1;
  &::-webkit-scrollbar {
    display: none;
  }
  > header {
    padding-top: 15px;
    position: relative;
    font-size: $font-lg;
    color: #424242;
    text-align: center;
    background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/red-envelope/probability_2.png');
    background-size: 100% 100%;
    color: #FFFFFF;
    height: 50px;
    > .back {
      position: absolute;
      left: 22px;
      font-size: $font-lg;
      box-sizing: content-box;
      padding: 5px { top: 0; left: 0 };
    }
    .typeList {
      position: absolute;
      bottom: 0;
      left: 15px;
      font-size: 0;
      > span {
        color: #FFFFFF;
        font-size: 10px;
        display: inline-block;
        width: 57px;
        height: 22px;
        text-align: center;
        line-height: 22px;
        background: linear-gradient(0deg, #A01A0E, #CD2C13);
        border-radius: 4px 4px 0px 0px;
        margin-right: 5px;
        &.active {
          background: linear-gradient(0deg, #FFFFFF, #FDF8DB);
          color: #894A21;
        }
      }
    }
    .condition {
      font-size: 0;
      background: linear-gradient(
        -90deg,
        rgba(255, 255, 234, 1),
        rgba(255, 236, 171, 1)
      );
      box-shadow: 0px 1px 4px 0 rgba(225, 104, 81, 0.36);
      border-radius: 15px 0 0 15px;
      padding: 5px 6px 4px 9px;
      color: #d05c47;
      display: flex;
      align-items: center;
      position: absolute;
      bottom: 2px;
      right: 0;
      > span {
        display: inline-block;
        font-size: $font-sm;
        vertical-align: bottom;
      }
    }
  }
  .bonusList {
    padding: 20px;
    height: 240px;
    overflow: auto;
    .bonusItem {
      font-size: 15px;
      .count {
        font-size: 12px;
        margin-bottom: 3px;
      }
      .list {
        margin-bottom: 10px;
        > li {
          width: 100%;
          display: flex;
          justify-content: space-between;
          color: #707070;
          font-size: 10px;
          line-height: 16px;
          .price {
            color: #FF0000;
          }
        }
      }
    }
  }
}
</style>